var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{staticClass:"select"},[_c('b-form-select',{attrs:{"value":_vm.n_activity.series,"options":_vm.seriesOptions},on:{"change":function($event){return _vm.updateSeries($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }